import React from 'react'
import {
    Form,
    Select,
} from 'antd'

const { Option } = Select

function Component(
    {
        layout,
        disabled,
        
        label = 'แท็กส์',
        name = 'tags',

        options,
        value,
        onChange,
    }
)
{
    return (
        <Form.Item 
            {...layout}
            label={label}
        >
            <Select 
                mode="tags"
                disabled={disabled}
                value={value}
                onChange={option => onChange(name, option)}
            >
                {
                    options.map(option =>
                    {
                        return (
                            <Option
                                key={`overview-tag-${option}`}
                                value={option}
                            >
                                {option}
                            </Option>
                        )  
                    })
                }
            </Select>
        </Form.Item>
    )
}

export default Component